import globalVariables from './globalVariables';

export default class urls {
    
    //static DEFAULT_IP = "127.0.0.1";  //url for local setup
    static DEFAULT_IP = "116.202.231.234:8000"; //production server IP
    // static DEFAULT_IP = "148.251.217.173:8002"; //development server IP
    // static DEFAULT_IP = "127.0.0.1:8002"; //docker setup
   //static DEFAULT_IP = "neudeep.in";

    static IP_ADDRESS = localStorage.getItem(globalVariables.IP_ADDRESS)

    static BASE_URL = `https://${this.DEFAULT_IP}` //"http://127.0.0.1:5000"
    // static BASE_URL = `http://${this.DEFAULT_IP}` //for docker setup

    //login, signin, tocken refresh APIs
    // static SIGNUP = urls.BASE_URL + "/sign_up"
    static TOKEN_REFRESH = urls.BASE_URL + "/api/account/token/refresh/"
    static LOGOUT = urls.BASE_URL + "/api/account/logout"

    //Associated Dealer ID
    static ASSOCIATED_DEALER_UUID = (id) => `${this.BASE_URL}/api/users/dealer_user/${id}/`

    // Clients/sites
    static CLIENT_CREATE = `${this.BASE_URL}/api/clients/`; // POST
    static GET_CLIENTS = `${this.BASE_URL}/api/clients/`; // GET
    static CLIENT_DETAILS = (clientId) => `${this.BASE_URL}/api/clients/${clientId}/`; // GET, PUT, DELETE  //usage => urls.CLIENT_DETAILS(clientId)
    static GET_SITES_BY_USER = `${this.BASE_URL}/api/sites/get-sites-by-user/`

    // Devices
    static GET_DEVICES = `${this.BASE_URL}/api/devices/`; // GET
    static CREATE_DEVICE = `${this.BASE_URL}/api/devices/create/`; // POST 
    static DEVICE_DETAILS = (deviceId) => `${this.BASE_URL}/api/devices/${deviceId}/`; // GET, PUT, DELETE
    static DEVICE_TYPE_LIST = `${this.BASE_URL}/api/device-types/` //GET
    //static ADD_DEVICE = `${this.BASE_URL}/api/devices/`; // POST (use this if the device is not reachable from CREATE_DEVICE api)
    static ADD_DEVICE = `${this.BASE_URL}/api/devices/add_device/`; // POST (new api for task list, use this if the device is not reachable from CREATE_DEVICE api)
    static GET_DEVICE_BY_DEALER = `${this.BASE_URL}/api/sites/get-devices-by-user/`;
    static REFRESH_DEVICE = `${this.BASE_URL}/api/devices/refresh_device/`; // GET (reload device, disk, timezone of one device in about device page)
    
    // Cameras
    static GET_CAMERAS = `${this.BASE_URL}/api/cameras/`; // GET to fetch all cameras
    static CREATE_CAMERA = `${this.BASE_URL}/api/cameras/`; // POST to create a camera
    static CAMERA_DETAILS = (cameraId) => `${this.BASE_URL}/api/cameras/${cameraId}/`; // GET, PUT, DELETE for specific camera
    static CAMERAS_BY_DEVICE = (deviceId) => `${this.BASE_URL}/api/cameras/device/${deviceId}/`; // GET cameras by device
    static CAMERA_HEALTH = (cameraId) => `${this.BASE_URL}/api/cameras/${cameraId}/health/`; // GET camera health status
    // static CAMERA_DETAILS2 = (cameraId) => `${this.BASE_URL}/api/cameras/${cameraId}/details/`; // GET detailed information of a specific camera

    //Mute-unmute camera notifications
    static CAMERA_NOTIFICATIONS_MUTE_UNMUTE =(cameraId) => `${this.BASE_URL}/api/cameras/${cameraId}/update-mute-status/`; //POST


    // Users
    //
    // static GET_USERS = `${this.BASE_URL}/api/users/`; // GET
    static GET_USERS = `${this.BASE_URL}/api/users/list`; //All users including dealer users too
    static GET_USERS_UNDER_ADMIN =(userId) => `${this.BASE_URL}/api/account/${userId}/customer_list/`; // GET
    static REGISTER = `${this.BASE_URL}/api/account/registration/`;
    static CREATE_USER = `${this.BASE_URL}/api/users/`; // POST
    static USER_DETAILS = (userId) => `${this.BASE_URL}/api/users/${userId}/get_user_profile/`; // GET, DELETE
    static UPDATE_USER_DEATILS = (userId) => `${this.BASE_URL}/api/users/${userId}/update_user_profile/`; // PUT
    static GET_USER_LIST_WITH_PERMISSIONS = (userId) => `${this.BASE_URL}/api/users/${userId}/get_user_list/`;
    static LOGIN = `${this.BASE_URL}/api/account/token/`;
    static VERIFY_EMAIL = `${this.BASE_URL}/api/account/verify-email/`;
    static DELETE_USER = (userId) => `${this.BASE_URL}/api/account/${userId}/user_delete/`;

    // Password Reset for Admin/Dealer users
    static RESET_PASSWORD = `${this.BASE_URL}/api/account/password/reset/`;
    static RESET_PASSWORD_CONFIRM = `${this.BASE_URL}/api/account/password/reset/confirm/`;

    // Reference Image Endpoints
    static REFERENCE_IMAGE_LIST = `${this.BASE_URL}/api/reference-images/`; //GET,POST
    static REFERENCE_IMAGE_DETAIL = (id) => `${this.BASE_URL}/api/reference-images/${id}/`; //GET,PUT,DELETE
    static LATEST_REFERENCE_IMAGE = (cameraId) => `${this.BASE_URL}/api/camera/${cameraId}/reference-images/latest/`; //GET
    static ALL_REFERENCE_IMAGES = (cameraId) => `${this.BASE_URL}/api/camera/${cameraId}/reference-images/`; //GET
    static SERVE_REFERENCE_IMAGE = (id) => `${this.BASE_URL}/api/reference-images/${id}/serve/`; //GET
    static GET_AI_RATING  = (id) => `${this.BASE_URL}/api/analyze-camera/${id}/`; //GET

    // Snapshot Endpoint
    static SNAPSHOT_URL = (cameraId) => `${this.BASE_URL}/api/snapshot/fetch-snapshot/${cameraId}/`; //GET
    static SNAPSHOT_BY_DATA = `${this.BASE_URL}/api/snapshot/fetch-snapshot-by-url/`
    static CAMERA_LATEST_IMAGES = (cameraId) => `${this.BASE_URL}/api/camera/${cameraId}/latest-images/`; // GET
    static OPERATOR_RATING = (cameraId) => `${this.BASE_URL}/api/cameras/${cameraId}/update-rating/`; // POST

    //Status Matrix Endpoints
    // static STATUS_MATRIX = `${this.BASE_URL}/api/status-metrix/`;
    //static STATUS_MATRIX = `${this.BASE_URL}/api/list-count-metrix-users/
    static STATUS_MATRIX = `${this.BASE_URL}/api/list_count_metrix_users_active/` //

    //Site list
    static SITE_MANAGE = `${this.BASE_URL}/api/sites/`; // For creating, updating, and deleting sites

    // Notification Settings Endpoints
    static NOTIFICATION_SETTINGS_LIST = `${this.BASE_URL}/api/notification-settings/`; // For listing all settings for logged in user
    static NOTIFICATION_SETTINGS_DETAIL = (id) => `${this.BASE_URL}/api/notification-settings/${id}/`; // For retrieving, updating, or deleting a specific
    static NOTIFICATION_SETTINGS_CREATE = `${this.BASE_URL}/api/notification-settings/`; // For creating a new setting pr updating an existing setting
    static SITE_MANAGE_ID = (id) => `${this.BASE_URL}/api/sites/${id}/`; // For getting, updating, and deleting a specific site
    static SITE_UPDATE_CUSTOM = (id) => `${this.BASE_URL}/api/sites/${id}/custom-update/`; // For getting, updating, and deleting a specific site
    static GET_DEVICES_BY_SITE = (siteId) => `${this.BASE_URL}/api/sites/${siteId}/devices/`; // GET

    //schedular related urls
    static SEND_TIME_BLOCK =`${this.BASE_URL}/api/create-multiple-schedules/`; // POST
    static GET_SCHEDULE_DATA = (id) =>`${this.BASE_URL}/api/${id}/schedules/`; // GET
    static DELETE_SCHEDULE_DATA = (id) =>`${this.BASE_URL}/api/schedules/${id}/`; // DELETE
    static UPDATE_SCHEDULE_DATA =`${this.BASE_URL}/api/update-schedules/`; // PUT
    static CLEAR_SCHEDULE_DATA = (id) =>`${this.BASE_URL}/api/clear-schedules/${id}/`; // DELETE

    //Test connection of device Endpoints
    static TEST_CONNECTION = `${this.BASE_URL}/api/devices/test_device/` //POST

    //Health Policy Template Endpoints
    static HEALTH_RECORDING_POLICY = `${this.BASE_URL}/api/recording-policies/` //POST / GET/ 
    static MANAGE_HEALTH_RECORDING_POLICY = (id) =>`${this.BASE_URL}/api/recording-policies/${id}/` // PUT / DELETE
    static SET_TEMPLATE_TO_MULTIPLE_DEVICES = `${this.BASE_URL}/api/devices/multiple/recording-policy/` //POST

    //Report generate
    static DOWNLOAD_REPORTS = `${this.BASE_URL}/api/download-report/` //POST
    static GENERATE_REPORT = `${this.BASE_URL}/api/generate-report/` //POST

    //get user details / user profile who have logged in
    static GET_PROFILE_DETAILS = (id) =>`${this.BASE_URL}/api/users/${id}/get_user_profile/`
    static UPDATE_PROFILE_DETAILS = (id) =>`${this.BASE_URL}/api/users/${id}/update_user_profile/`

    //User activity logs
    // static GET_ALL_USERS_ACTIVITY_LOGS = `${this.BASE_URL}/api/users/activity-logs-users/?model=Device&start_date=2025-01-17&end_date=2025-01-20`

    static GET_ALL_USERS_ACTIVITY_LOGS = (model, start_date, end_date) => `${this.BASE_URL}/api/users/activity-logs-users/?model=${model}&start_date=${start_date}&end_date=${end_date}`
}